import $ from 'jquery';

function initCopyContest() {
  const copyButtons = document.querySelectorAll('.copy-contest');
  const actionLink = document.querySelectorAll('.action-link');

  if (!copyButtons.length) {
    return;
  }

  const modalSelector = '#paid-settings-modal[data-event-source-id="copy-contest-button"]';
  const paidSettingsModal = document.querySelector(modalSelector);

  if (!paidSettingsModal) {
    return;
  }

  copyButtons.forEach(function (button) {
    button.addEventListener('click', async function (e) {
      const copyButton = e.currentTarget;
      const url = copyButton.getAttribute('data-url');
      const modalHeader = paidSettingsModal.querySelector('.popup-header');
      const modalBody = paidSettingsModal.querySelector('.popup-content');
      modalHeader.innerHTML = '';
      modalBody.innerHTML = '';
      const modalActionLink = paidSettingsModal.querySelector('.action-link');
      const modalActionLinkMessage = modalActionLink.querySelector('.action-link-message');
      const response = await fetch(url);
      const result = await response.json();

      modalHeader.innerHTML = result.modalHeader;
      result.messages?.forEach(function (message) {
        const messageHtml = document.createElement('p');
        messageHtml.innerHTML = message;
        modalBody.appendChild(messageHtml);
      });

      if (result.status === 'success') {
        if (result.messageType === 'available_option_error') {
          modalActionLink.href = result.shopUrl;
          modalActionLinkMessage.textContent = 'Магазин';
        } else if (result.messageType === 'need_to_pay_options') {
          modalActionLink.href = result.copyContestUrl;
          modalActionLinkMessage.textContent = 'Копировать';
        } else if (result.messageType === 'can_copy_contest') {
          window.location.href = result.redirectTo;

          return;
        }
      }

      const overlay = $('#overlay');
      overlay.addClass('cabinet-contest-modal');
      overlay.fadeIn();
      paidSettingsModal.classList.add('active');

      return;
    });
  });
}

export { initCopyContest }